import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      class: "waste-svg-fill"
    }, [
      _createElementVNode("path", { d: "M21.642 3.776c-.211-.605-.801-1.011-1.468-1.011h-4.657v-1.45C15.517.59 14.9 0 14.143 0H9.878C9.12 0 8.504.59 8.504 1.315v1.45H3.847c-.667 0-1.257.406-1.468 1.011l-.554 1.588c-.126.362-.062.762.17 1.072.234.309.61.494 1.01.494h.578l1.275 15.075C4.953 23.123 5.946 24 7.118 24h10.043c1.172 0 2.165-.877 2.26-1.995L20.696 6.93h.32c.4 0 .776-.185 1.01-.494.232-.31.296-.71.17-1.072zM9.975 1.406h4.072v1.359H9.975zm7.98 20.486c-.033.394-.382.702-.794.702H7.12c-.412 0-.76-.308-.794-.702L5.06 6.93h14.162zM3.32 5.524l.454-1.303c.01-.03.04-.05.073-.05h16.328c.033 0 .062.02.073.05l.454 1.303z" }),
      _createElementVNode("path", { d: "M15.61 21.842h.039c.388 0 .713-.29.733-.666l.69-12.675c.022-.387-.29-.718-.695-.738-.407-.021-.751.277-.773.665l-.69 12.675c-.021.388.29.719.696.739M7.671 21.178c.022.374.346.664.734.664h.04c.406-.022.717-.353.695-.74L8.416 8.425c-.022-.388-.368-.685-.774-.664-.405.022-.716.353-.694.74zM12.019 21.843c.406 0 .735-.315.735-.703V8.465c0-.388-.329-.703-.735-.703s-.735.315-.735.703V21.14c0 .388.329.703.735.703" })
    ], -1)
  ])))
}
export default { render: render }